<div class="dialog-backdrop transparent"></div>
<div
  [@fadePink]="animationState"
  (@fadePink.start)="onAnimationStart($event)"
  (@fadePink.done)="onAnimationDone($event)"
  class="dialog-backdrop pink"
></div>
